module.exports = (v) => () => v;
